import React, { useMemo } from "react"
import { AiOutlineDelete } from "react-icons/ai"
import useCartContext from "../context/CartContext"
import useProducts from "../context/ProductsContext"

const CartItem = ({ item }) => {
  const { products, isLoading } = useProducts()
  const { increaseCartQuantity, decreaseCartQuantity, removeCartItem } =
    useCartContext()

  const selectedItem = useMemo(() => {
    if (isLoading) return null
    return products?.find((p) => p.id === item.id)
  }, [products, isLoading, item.id])

  if (!selectedItem) return null

  return (
    <div className="cart-item">
      <div className="cart-item-grid">
        <div className="col preview">
          <div className="cart-img">
            <img src={selectedItem.previews[0]} alt="" />
          </div>
          <p className="cart-item-name slide-name">{selectedItem.name}</p>
        </div>
        <div className="col quantity">
          <p>Quantity</p>
          <div className="quantity-adjust">
            <button onClick={() => decreaseCartQuantity(item.id)}>-</button>
            <span className="quantity-amount">{item.quantity}</span>
            <button onClick={() => increaseCartQuantity(item.id)}>+</button>
          </div>
        </div>
        <div className="col actions">
          <button onClick={() => removeCartItem(item.id)}>
            remove <AiOutlineDelete />
          </button>
          <p className="cart-item-name slide-name">${selectedItem.price}</p>
        </div>
      </div>
    </div>
  )
}
export default CartItem
